import { Button } from '../../components/Button';

interface LoginHeroProps {
  showMobile: boolean;
  onGetStarted: () => void;
  onLogin: () => void;
}

/**
 * Hero section for the login page - shows the visual background and tagline.
 * Hidden on mobile when the auth form is shown.
 */
export const LoginHero = ({ showMobile, onGetStarted, onLogin }: LoginHeroProps) => {
  return (
    <div className={`relative w-0 flex-1 ${showMobile ? 'block' : 'hidden lg:block'}`}>
      <img
        className="absolute inset-0 h-full w-full object-cover"
        src="/default-trip-header.jpg"
        alt="TripVibes Background"
      />

      {/* Mobile Top Right CTA */}
      <Button variant="outline" onClick={onLogin} className="lg:hidden absolute top-8 right-6 z-30">
        Log In
      </Button>

      {/* Tagline and CTA */}
      <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-neutral-darkest to-transparent p-12 pb-24 lg:pb-12">
        <div className="max-w-md">
          <div className="mb-8 lg:hidden">
            <Button variant="primary" size="lg" onClick={onGetStarted}>
              Get Started
            </Button>
          </div>
          <h1 className="text-5xl font-extrabold tracking-tight text-on-dark">
            Turn your trips into stories worth sharing
          </h1>
          <p className="mt-6 text-xl font-bold leading-relaxed text-on-dark">
            TripVibes is your digital photobook: share your adventures with friends, family or just
            for yourself - privacy-friendly and free forever.
          </p>
        </div>
      </div>
    </div>
  );
};
